<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Identificação do paciente"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nomeSocial"
                        disabled
                        label="Nome social"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.idade"
                        disabled
                        label="Idade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.prontuario"
                        disabled
                        label="Prontuário municipal"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :mask="mask.cpf"
                        :value="form.paciente.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.nomeMae"
                        disabled
                        label="Nome da mãe"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.telefone"
                        disabled
                        label="Telefone"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.municipioUf"
                        disabled
                        label="Município / Estado"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="form.paciente.unidadeReferencia"
                        disabled
                        label="Unidade de referência"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.classificacao"
                        disabled
                        label="Classificação"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.paciente.validadeFim"
                        disabled
                        label="Validade do cadastro"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <FormBusca
            :form="form"
            :model="model"
            :paciente-id="id"
            @cleaned="agendamentos = $event"
            @searched="agendamentos = $event"
            ref="FormBusca"
        />

        <ListBusca
            :additionals="additionals"
            :agendamentos="agendamentos"
            :paciente-id="id"
            @canceled="$refs.FormBusca.search()"
            @deleted="$refs.FormBusca.search()"
            @updated="$refs.FormBusca.search()"
        />
    </div>
</template>

<script>
// Components.
import FormBusca from './components/busca/Form'
import ListBusca from './components/busca/List'

// Mixins.
import {error, mask, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        FormBusca,
        ListBusca,
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('ambulatorio.agendamento'),
        }
    },
    data: () => ({
        additionals: null,
        form: null,
        agendamentos: [],
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.agendamento.create(this.id, this.camelObjectKeysToSnakeRecursive({origem: 'busca'}))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.agendamentos = Object.assign(response.data.agendamentos)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    if (this.model.periodo.start) {
                        this.model.periodo.start = this.others.moment(this.model.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }

                    if (this.model.periodo.end) {
                        this.model.periodo.end = this.others.moment(this.model.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }

                    this.addWatch()

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatch() {
            this.$watch('model', {
                deep: true,
                handler() {
                    this.agendamentos = []
                },
            })
        },
    },
    mixins: [error, mask, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: [Number, String], required: true},
    },
}
</script>